import { useAppState } from '@sky-distribution/gp-onboarding-app-state-service';
import { getRouteWithSearchQuery, safeWindow, addDataLayer } from '@sky-distribution/gp-onboarding-shared-utils';
import { Fragment, useContext, useEffect } from 'react';
import { XRouterContext } from './XRouter';

const PAGE_CHANGE_EVENT_NAME = 'pageChange';

export const resolvePath = (...pathParts: string[]): string => pathParts.join('/')
  .replace(/\/+/g, '/');

export const useRouting = (): void => {
  const { basename } = useContext(XRouterContext);
  const {
    context: { route },
    previous,
  } = useAppState();

  useEffect(() => {
    if (route) {
      const routeWithQueryString = getRouteWithSearchQuery(route);

      safeWindow()?.history?.pushState(
        null,
        '',
        resolvePath(basename, routeWithQueryString),
      );
      addDataLayer(PAGE_CHANGE_EVENT_NAME, route);
    }
  }, [route, basename]);

  useEffect(() => {
    const { addEventListener } = safeWindow();

    if (addEventListener) {
      addEventListener('popstate', () => {
        previous();
      });
    }
  }, [previous]);
};

export const BrowserRouting = ({
  children,
}: {
  children?: React.ReactNode;
}): JSX.Element => {
  useRouting();

  return <Fragment>{children}</Fragment>;
};
